let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("86h7F")).then(() => parcelRequire('ivLVn'));